(function () {
    'use strict';

    angular
        .module('core.directives')
        .directive('validateDate', ValidateDate);

    function ValidateDate(ValidatorHelper) {
        function testDate(date) {
            if (!date)
                return true;

            return ValidatorHelper.validateDate(date);
        }

        function link(scope, elem, attrs, ctrl) {
            scope.$watch(attrs.ngModel, function (value) {
                if (testDate(value))
                    ctrl.$setValidity('date', true);
                else
                    ctrl.$setValidity('date', false);
            })
        }

        return {
            restrict: 'A',
            require: 'ngModel',
            link: link
        }
    }
}());